// 普通用户信息管理页面
import React, { useRef, useState, useEffect } from 'react'
import styles from './TeacherInfoManager.module.css'
import classNames from 'classnames'
import {
  Button,
  Col,
  ConfigProvider,
  Flex,
  Form,
  Input,
  Popconfirm,
  Row,
  Select,
  Space,
  Upload,
  message,
} from 'antd'
import {
  DeleteColumnOutlined,
  DeleteOutlined,
  LeftOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import OSS from 'ali-oss'
import {
  getAliOssTokenRequest,
  getUserInfoRequest,
  updateTeacherUserInfoRequest,
  updateUserInfoRequest,
} from './api'
import { getSixMathRandom } from '../../../util/handMath'
import { ALI_OSS_PATH } from '../../../util/constants'
import { clearAllCookies } from '../../../util/handleObject'
import locale from 'antd/locale/zh_CN'
import deleteIcon from './delete.svg'
import IdentityInfo from './IdentityInfo'
import BZRIdentityInfo from './BZRIdentityInfo'
import OtherIdentityInfo from './OtherIdentityInfo'
import { closeAdminPage, closeHomePage, openLogin } from '../../../store/modalsSlice'
import { useDispatch } from 'react-redux'

let client
let clientExpTime
export default function TeacherInfoManager(props) {
  const dispatch = useDispatch()
  const [userInfo, setUserInfo] = useState({
    user_login: '',
    school_name: '',
  })
  const [identityList, setIdentityList] = useState([])
  const [xuekeList, setXuekeList] = useState([])
  const [gradeList, setGradeList] = useState([])
  const [avatar, setAvatar] = useState('')
  const [form] = Form.useForm()

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    getUserInfo()
    getAliOssToken()
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  function getUserInfo() {
    getUserInfoRequest((data) => {
      if (data.ret == 1) {
        let userInfo = data.data.user_info
        setUserInfo(userInfo)
        form.setFieldsValue(userInfo)
        setAvatar(userInfo.image_url)


        setIdentityList(data.data.shenfen)
        setXuekeList(data.data.xueke_list)
        setGradeList(data.data.nianji_list)
      } else if (data.ret == 99) {
        message.warning(data.msg)
        setTimeout((e) => {
          sessionStorage.clear()
          clearAllCookies()
          window.location.reload()
        }, 1000)
      } else {
        message.warning(data.msg)
      }
    })
  }

  function getAliOssToken() {
    let nowDate = new Date().getTime()
    if (!client || nowDate - clientExpTime > 1200000) {
      clientExpTime = new Date().getTime()
      getAliOssTokenRequest((data) => {
        if ('Credentials' in data) {
          client = new OSS({
            // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
            region: 'oss-cn-qingdao',
            // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
            accessKeyId: data.Credentials.AccessKeyId,
            accessKeySecret: data.Credentials.AccessKeySecret,
            // 从STS服务获取的安全令牌（SecurityToken）。
            stsToken: data.Credentials.SecurityToken,
            refreshSTSToken: async () => {
              // 向您搭建的STS服务获取临时访问凭证。
              getAliOssTokenRequest((data) => {
                return {
                  accessKeyId: data.Credentials.AccessKeyId,
                  accessKeySecret: data.Credentials.AccessKeySecret,
                  stsToken: data.Credentials.SecurityToken,
                }
              })
            },
            // 刷新临时访问凭证的时间间隔，单位为毫秒。
            refreshSTSTokenInterval: 3000000,
            // 填写Bucket名称。
            bucket: 'tgnp',
          })
        }
      })
    }
  }
  function handleChange1(info) {
    getAliOssToken()
    let tempList = info.fileList.map((item, index) => {
      let tempDic = {
        url: item.url,
        uid: item.uid,
        status: item.status,
        name: item.name,
      }
      return tempDic
    })
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList)
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`)
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`)
    }
  }

  const customRequest = async (options) => {
    const { onSuccess, onError, file } = options

    try {
      // 使用阿里云OSS SDK上传文件
      let timestamp = new Date().getTime()
      let random = getSixMathRandom()
      const result = await client.put(
        ALI_OSS_PATH + 'user/' + timestamp + random + file.name,
        file,
      )
      file.url = result.url.replace('http:', 'https:')
      onSuccess(file)
      changeImgMethod(file.url)
    } catch (e) {
      message.error(`头像上传失败`)
      onError(e)
    }
  }

  function changeImgMethod(url) {
    form.setFieldValue('image_url', url)
    setAvatar(url)
  }
  function onFinish(values) {

    console.log(identityList)
    if (identityList.some((item) => item.type == 3 && (item.qita_content == ''||item.qita_content==null))) {
      message.warning('请加查其他身份内容是否为空')
      return
    }

    let identityInfoJson = JSON.stringify(identityList.map((item)=>{
      if(item.type == 1){
        return {
          shenfen_type: item.type,
          nianji: item.nianji,
          nianji_code: item.nianji_code,
          xueke: item.xueke,
          xueke_code: item.xueke_code,
          status: "1"
        }
      }
      else if(item.type == 2){
        return {
          
          shenfen_type: item.type,
          nianji: item.nianji,
          nianji_code: item.nianji_code,
          status: "1"
        }
      }
      else if(item.type == 3){
        return {
          shenfen_type: item.type,
          qita_content: item.qita_content,
          status: "1"
        }
      }
    }))
    updateTeacherUserInfoRequest(values.image_url, values.name, values.pwd,identityInfoJson, (data) => {
      console.log(data)
      if (data.ret == 1) {
        props.changeUserName(values.name)
        props.changeUserAvatar(values.image_url)
        setUserInfo({
          ...userInfo,
          name: values.name,
          image_url: values.image_url,
          pwd: values.pwd,
        })
        setAvatar(values.image_url)

        message.success('保存成功')
      } else if (data.ret == 99) {
        message.warning(data.msg)
        setTimeout((e) => {
          sessionStorage.clear()
          clearAllCookies()
          window.location.reload()
        }, 1000)
      } else {
        message.error(data.msg)
      }
    })
  }

  function handleIdentityTypeChange(index, typeInfo) {
    setIdentityList(
      identityList.map((item, i) =>
        i === index ? { ...item, type: typeInfo.value } : item,
      ),
    )
  }
  return (
    <div className={styles.background}>
      <Button
        onClick={() => {
          props.onCancel()
        }}
        icon={<LeftOutlined />}
        type="text"
        style={{
          fontSize: 18,
        }}
      >
        返回
      </Button>
      <div className={styles.infoContainer} style={{position:'relative'}}>
        <div className={styles.titleText}>编辑个人信息</div>
        <div className={styles.desText}>完善您的个人资料，以便更好地使用</div>
        {/* <ConfigProvider
          locale={locale}
          theme={{
            token: {
              colorPrimary: '#F5B544',
            },
          }}
        >
          <Popconfirm
            placement="bottom"
            title={''}
            description={'是否退出登录'}
            okText="是"
            cancelText="否"
            onConfirm={(e) => {
              props.onCancel()
              sessionStorage.clear()
              clearAllCookies()
              dispatch(closeHomePage())
              dispatch(openLogin())
            }}
          >
            <Button
              type="primary"
              style={{
                top: 10,
                right: 'calc(50% - 430px)',
                position: 'absolute',
              }}
            >
              退出登录
            </Button>
          </Popconfirm>
        </ConfigProvider> */}
        <div className={styles.editInfoContainer}>
          <ConfigProvider
            locale={locale}
            theme={{
              components: {
                Form: {
                  labelFontSize: 18,
                },
              },
            }}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              style={{ marginTop: 50, width: 680, marginBottom: 70 }}
              size="large"
            >
              <Form.Item
                label=""
                name="image_url"
                rules={[{ required: false, message: '请输入应用名称' }]}
                labelAlign="right"
                wrapperCol={{ offset: 10 }}
              >
                <Upload
                  listType="picture"
                  fileList={[]}
                  onChange={handleChange1}
                  customRequest={customRequest}
                  accept=".jpg,.png,.jpeg,.svg"
                >
                  <img
                    className={styles.avatar}
                    src={
                      avatar == null || avatar == 'null' || avatar == ''
                        ? require('../avatar.png')
                        : avatar
                    }
                  ></img>
                  <div className={styles.uploadText}>点击更换头像</div>
                </Upload>
              </Form.Item>

              <Form.Item
                label="姓名"
                name="name"
                rules={[{ required: true, message: '姓名不能为空' }]}
                labelAlign="right"
                style={{ marginTop: 40 }}
              >
                <Input
                  placeholder="请输入姓名1"
                  size="large"
                  // value={name}
                  onChange={(e) => {
                    console.log(e.target.value)
                    // setName(e.target.value)
                  }}
                />
              </Form.Item>

              <Form.Item
                label="账号（手机号）"
                name="user_login"
                rules={[{ required: false, message: '请输入应用名称' }]}
                labelAlign="right"
              >
                {/* <text className={styles.rightText}>{userInfo.user_login}</text> */}
                <Input size="large" value={userInfo.user_login} disabled />
              </Form.Item>

              <Form.Item
                label="密码"
                name="pwd"
                rules={[{ required: true, message: '密码不能为空' }]}
                labelAlign="right"
              >
                <Input.Password
                  placeholder="请输入登录密码"
                  size="large"
                  style={{ backgroundColor: 'white' }}
                />
              </Form.Item>
              <Form.Item
                label="在校身份信息"
                name="identity_info"
                rules={[{ required: false, message: '请输入在校身份信息' }]}
                labelAlign="right"
              >
                {identityList.map((item, index) =>
                  item.type == 1 ? (
                    <IdentityInfo
                      key={index}
                      index={index}
                      info={item}
                      handleIdentityTypeChange={handleIdentityTypeChange}
                      handleDelete={() => {
                        if(identityList.length == 1) {
                          message.warning("至少保留一个身份信息")
                          return
                        }
                        setIdentityList(identityList.filter((item, i) => i !== index))
                      }}
                      handleXuekeChange={(index, typeInfo)=>{
                        setIdentityList(identityList.map((item, i) =>
                          i == index ? { ...item, xueke_code: typeInfo.value } : item
                        ))
                      }}
                      handleGradeChange={(index, typeInfo)=>{
                        setIdentityList(identityList.map((item, i) =>
                          i == index ? { ...item, nianji_code: typeInfo.value } : item
                        ))
                      }}
                      xuekeList={xuekeList}
                      gradeList={gradeList}
                    />
                  ) : item.type == 2 ? (
                    <BZRIdentityInfo
                      key={index}
                      index={index}
                      info={item}
                      handleIdentityTypeChange={handleIdentityTypeChange}
                      handleDelete={() => {
                        if(identityList.length == 1) {
                          message.warning("至少保留一个身份信息")
                          return
                        }
                        setIdentityList(identityList.filter((item, i) => i !== index))
                      }}
                      handleGradeChange={(index, typeInfo)=>{
                        setIdentityList(identityList.map((item, i) =>
                          i == index ? { ...item, nianji_code: typeInfo.value } : item
                        ))
                      }}
                      gradeList={gradeList}
                    />
                  ) : (
                    <OtherIdentityInfo
                      key={index}
                      index={index}
                      info={item}
                      handleIdentityTypeChange={handleIdentityTypeChange}
                      handleDelete={() => {
                        if(identityList.length == 1) {
                          message.warning("至少保留一个身份信息")
                          return
                        }
                        setIdentityList(identityList.filter((item, i) => i !== index))
                      }}
                      handleQitaContentChange={(index, value)=>{
                        setIdentityList(identityList.map((item, i) =>
                          i == index ? { ...item, qita_content: value } : item
                        ))
                      }}
                      xuekeList={xuekeList}
                      gradeList={gradeList}
                    />
                  ),
                )}
                <Button
                  color="primary"
                  variant="link"
                  icon={<PlusOutlined />}
                  style={{
                    marginTop: 20,
                    marginLeft: -10,
                    color: '#F59E0B',
                  }}
                  onClick={() => {
                    setIdentityList([
                      ...identityList,
                      {
                        type: '1',
                        nianji: '一年级',
                        nianji_code: 'grade1',
                        xueke: '语文',
                        xueke_code: 'subject1',
                        qita_content: null
                      },
                    ])
                  }}
                >
                  添加身份信息
                </Button>
              </Form.Item>
              <Form.Item
                label="所属学校"
                name="school_name"
                rules={[{ required: false, message: '请输入应用名称' }]}
                labelAlign="right"
              >
                {/* <text className={styles.rightText}>{userInfo.school_name}</text> */}
                <Input size="large" value={userInfo.school_name} disabled />
              </Form.Item>
              <Form.Item style={{ marginTop: 80 }}>
                <Flex justify="end">
                  <Button
                    htmlType="button"
                    style={{ backgroundColor: 'white', width: 100 }}
                    onClick={() => {
                      form.setFieldsValue(userInfo)
                      setAvatar(userInfo.image_url)
                      props.onCancel()
                    }}
                  >
                    取消
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      marginLeft: 30,
                      width: 100,
                      backgroundColor: '#F7C469',
                    }}
                  >
                    保存修改
                  </Button>
                </Flex>
              </Form.Item>
            </Form>
          </ConfigProvider>
        </div>
      </div>
    </div>
  )
}
